import Vue from 'vue'
import Vuex from 'vuex'

// Import the `getField` getter and the `updateField`
// mutation function from the `vuex-map-fields` module.
import { getField } from 'vuex-map-fields'

// Root Actions
// https://vuex.vuejs.org/guide/actions.html
import actions from './actions'

// Root Mutations
// https://vuex.vuejs.org/guide/mutations.html
import mutations from './mutations'

import createLogger from './plugins/logger'

Vue.use(Vuex)

// Strict Mode
// https://vuex.vuejs.org/guide/strict.html
const debug = process.env.NODE_ENV !== 'production'

// Root State
// https://vuex.vuejs.org/guide/state.html
const state = {
  loading: true,
  config: {},
  formJson: {},
  formDataId: {},
  failure: {},
  isFail: false,
  loadEvents: false,
  onBlurFocus: '',
  showOnly: {}
}

// Root getters
// https://vuex.vuejs.org/guide/getters.html
const getters = {
  // Add the `getField` getter to the
  // `getters` of your Vuex store instance.
  getField,
  config: state => state.config,
  form: state => state.form
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: false,
  plugins: debug ? [createLogger()] : []
})
